export enum PartnerFlagRequestAction {
  Add = 'Add',
  Modify = 'Modify',
  Remove = 'Remove',
}

export enum PartnerFlagRequestStatus {
  New = 'New',
  Done = 'Done',
  WIP = 'WIP',
  Rejected = 'Rejected',
}
